import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import RedRoundBtn from "../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn";
import "./TermLifeInsuarance.css";
import TermInsuranceStepform from "../Common_Component/Common_Modal/TermInsuranceStepform/TermInsuranceStepform";
import { Link, useLocation } from "react-router-dom";
import You_Are_Almost_There_Modal from "../Common_Component/Common_Modal/You_Are_Almost_There_Modal/You_Are_Almost_There_Modal";
import Cookies from "js-cookie";
const TermLifeInsuarance = () => {
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState();
  const [showSuccessModalNew, setSuccessShowModalNew] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const dateInputRef = useRef(null);

  const handleClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };

  const location = useLocation();

  // Create a URLSearchParams instance from the location's search property
  const queryParams = new URLSearchParams(location.search);
  const [selectedGender, setSelectedGender] = useState("Male");

  // Get the value of the "name" query parameter
  const name = queryParams.get("name");
  const type = queryParams.get("type");

  const onSubmit = async (data) => {
    data.service = name;
    data.type = type;
    data.gender = selectedGender;
    setData(data);
    setShowModal(true);
  };

  const handleGenderSelect = (event) => {
    setSelectedGender(event.target.value);
  };

  const user_data = Cookies.get("user_data"); // Get the value of 'status' cookie

  useEffect(() => {
    if (user_data) {
      const parsedData = JSON.parse(user_data);
      reset(parsedData);
      setSelectedGender(parsedData?.gender);
    }

    // setData(parsedData);
  }, [user_data]);

  return (
    <section className="TermLifeInsuarance">
      <div className="row me-0 ms-0">
        <div className="col-lg-3 col-md-3 col-sm-3 p-0">
          <div className="leftside_bg_div">
            <Link to="/" className="icon_holder">
              <FontAwesomeIcon icon={faHome} className="home_icon" />
            </Link>

            <div className="verticle_text">
              <p className="text1">TERM LIFE</p>

              <p className="text2">{type}</p>
            </div>
          </div>
        </div>

        <div className="col-lg-9 col-md-9 col-sm-9">
          <div className="">
            <div className="right_side_div">
              <div className="discount_div">
                <p className="discount_text">
                  Get an Online discount of{" "}
                  <span className="inner_text">upto 15%</span>
                </p>
              </div>

              <div className="d-flex justify-content-center custom_div">
                {/* Male Option */}
                <label className="gender_main_holder">
                  <input
                    type="radio"
                    name="gender"
                    value="Male"
                    checked={selectedGender === "Male"}
                    className="d-none"
                    onClick={handleGenderSelect}
                  />
                  <div className="main_content_holder">
                    <div className="img_holder">
                      <img
                        src="/assets/Image/term_lifeinsuarnce/male.png"
                        className="img"
                      />
                    </div>
                    <div className="overlay_colour"></div>
                    <div className="overlay_colour2"></div>
                  </div>
                  <p className="gender_text">Male</p>
                </label>

                {/* Female Option */}
                <label className="gender_main_holder">
                  <input
                    type="radio"
                    name="gender"
                    value="Female"
                    className="d-none"
                    checked={selectedGender === "Female"}
                    onClick={handleGenderSelect}
                  />
                  <div className="main_content_holder">
                    <div className="img_holder">
                      <img
                        src="/assets/Image/term_lifeinsuarnce/female.png"
                        className="img"
                      />
                    </div>
                    <div className="overlay_colour"></div>
                    <div className="overlay_colour2"></div>
                  </div>
                  <p className="gender_text">Female</p>
                </label>
              </div>

              <div className="form_holder">
                <Form
                  className="tl_insurance_form edit_p_form"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Form.Group className="blue_label_group">
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      {...register("name", {
                        required: "Name is required",
                      })}
                    />
                    {errors?.name && (
                      <span className="invalid-feedback d-block">
                        {errors.name.message}
                      </span>
                    )}
                  </Form.Group>

                  <Form.Group className="blue_label_group">
                    <Form.Label>Date of Birth</Form.Label>
                    <Form.Control
                      ref={dateInputRef}
                      type="date"
                      name="name"
                      {...register("dob", {
                        required: "Date of Birth is required",
                      })}
                      placeholder="Date of Birth"
                      onClick={handleClick}
                    />
                    {errors?.dob && (
                      <span className="invalid-feedback d-block">
                        {errors.dob.message}
                      </span>
                    )}
                  </Form.Group>

                  <Form.Group className="blue_label_group">
                    <Form.Label>Mobile Number</Form.Label>

                    <Controller
                      name="contact_no"
                      control={control}
                      country={"in"}
                      rules={{
                        required: "Mobile Number is required",
                        pattern: {
                          value: /^\+?\d{1,4}[-\s]?\d{10}$/,
                          message:
                            "Invalid number format. Please enter a valid number with an optional country code",
                        },
                      }}
                      render={({ field }) => (
                        <PhoneInput
                          {...field}
                          country={"in"}
                          onChange={(value) => field.onChange(value)}
                          type="text"
                          placeholder="Enter Mobile Number"
                          maxLength={10}
                        />
                      )}
                    />
                    {errors?.contact_no && (
                      <sup className="text-danger">
                        {errors?.contact_no?.message}
                      </sup>
                    )}
                  </Form.Group>

                  <div className="btn_holder">
                    <RedRoundBtn
                      btn_name="View Plans"
                      type="submit"

                      // onClick={() => {
                      //     setShowModal(true)
                      // }}
                    />
                  </div>

                  <div className="form_footer">
                    <div className="icon_holder">
                      <img
                        src="\assets\Image\term_lifeinsuarnce\wp.png"
                        className="wp_img"
                      />
                    </div>
                    <p className="text">Get updates on WhatsApp</p>

                    <div className="switch_btn">
                      <Form.Check // prettier-ignore
                        type="switch"
                        id="custom-switch"
                      />
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TermInsuranceStepform
        show={showModal}
        data={data}
        onHide={() => {
          setShowModal(false);
        }}
        setSuccessShowModalNew={setSuccessShowModalNew}
      />

      {showSuccessModalNew && (
        <You_Are_Almost_There_Modal
          text={
            type === "LOAN"
              ? "Request sent successfully."
              : "You are almost there!"
          }
          show={showSuccessModalNew}
          onHide={() => {
            setSuccessShowModalNew(false);
          }}
          navigate={type === "LOAN" ? "/" : "/loan-compare"}
        />
      )}
    </section>
  );
};

export default TermLifeInsuarance;
